export default {
  common: { all: '全部' },
  actions: {
    publishHomework: '发布作业', search: '查询', reset: '重置', view: '查看', edit: '编辑', delete: '删除',
    confirmDelete: '确认删除', cancel: '取消', back: '返回', publish: '发布', schedulePublish: '预约发布',
    saveChanges: '保存修改', confirmPublish: '确认发布', confirmUpdate: '确认保存', uploadAttachment: '上传文件',
    preview: '预览附件', remove: '移除',
  },
  fields: {
    title: '作业标题', schoolYear: '学年', grade: '级组', class: '班级', targetClasses: '发布班级',
    subject: '科目', status: '状态', homeworkDate: '作业日期', estimatedMinutes: '预计完成时间',
    dueTime: '截止时间', publishDate: '发布日期', publishTime: '发布时间', publishCutoffTime: '发布截止时间',
    publishMode: '发布方式', scheduledPublishTime: '预约发布时间', content: '作业内容',
    attachments: '附件', operation: '操作', publishTimeliness: '发布时效', publisher: '发布人', withdrawTime: '撤回时间',
  },
  placeholders: {
    title: '请输入作业标题', schoolYear: '请选择学年', subject: '请选择科目', classes: '请选择班级（可多选）',
    homeworkDate: '请选择作业日期', publishDate: '请选择发布日期', estimatedMinutes: '请输入分钟数', dueTime: '请选择截止时间',
    scheduledPublishTime: '请选择预约发布时间', content: '请输入作业内容',
  },
  status: { published: '已发布', withdrawn: '已撤回', scheduled: '待发布', ended: '已截止' },
  timeliness: { normal: '正常发布', overtime: '超时发布' },
  publishMode: { immediate: '立即发布', scheduled: '预约发布' },
  editor: {
    createTitle: '发布学生作业', editTitle: '编辑学生作业', subtitle: '填写作业内容并选择发布班级',
    homeworkInfo: '作业内容', publishRuleTitle: '发布说明',
    publishRuleDescription: '作业日期和截止时间均以服务端业务时区为准；预约发布时间必须早于学生完成截止时间。',
  },
  validation: {
    schoolYearRequired: '请选择学年', subjectRequired: '请选择科目', classRequired: '请至少选择一个班级',
    homeworkDateRequired: '请选择作业日期', homeworkDatePast: '作业日期不能早于今天', titleRequired: '请输入作业标题',
    titleLength: '作业标题最多 50 个字符', contentRequired: '请输入作业内容', contentLength: '作业内容最多 16000 个字符',
    estimatedMinutesRequired: '请输入预计完成时间', estimatedMinutesRange: '预计完成时间需介于 1 至 65535 分钟',
    dueTimeRequired: '请选择截止时间', futureTime: '时间必须晚于当前时间', dueAfterHomeworkDate: '截止时间不能早于作业日期',
    scheduledTimeRequired: '请选择预约发布时间',
    scheduleBeforeDueTime: '预约发布时间必须早于截止时间',
  },
  messages: {
    loadDetailFailed: '作业详情加载失败', scopeChanged: '当前任教范围已变更，请重新选择科目和班级',
    publishTitle: '确认发布作业？', publishDescription: '发布后将立即向选定班级的学生推送作业。',
    updateTitle: '确认保存修改？', updateDescription: '保存时会以当前班级和附件完整集合覆盖原内容。',
    publishSuccess: '作业已发布', scheduleSuccess: '作业已预约发布', updateSuccess: '作业修改成功',
    deleteTitle: '删除作业？', deleteDescription: '删除后作业及其相关数据将无法恢复，请确认是否删除。',
    deleteSuccess: '作业已删除', uploadSuccess: '附件上传成功', uploadFailed: '附件上传失败', attachmentFormatUnsupported: '不支持该附件格式，请上传 PDF、图片、PPT、Word 或 Excel 文件', previewFailed: '附件预览失败', previewOpenFailed: '浏览器拦截了预览窗口，请允许弹窗后重试',
    spreadsheetPreviewEmpty: '表格中没有可预览的数据', spreadsheetPreviewTruncated: '表格较大，仅展示前 {rows} 行和 {columns} 列', spreadsheetPreviewFailed: '表格文件预览失败',
  },
  states: { loading: '正在加载作业列表...', empty: '当前筛选条件下暂无作业', noAttachments: '暂无附件' },
  tips: { attachment: '支持 PDF、图片、PPT、Word、Excel 等常用格式；附件需先上传，发布或保存时才会与作业绑定。' },
  units: { minute: ' 分钟' },
}
